document.addEventListener("DOMContentLoaded", function () {
  const backButton = document.getElementById("article_back-btn");

  backButton.addEventListener("click", function () {
    const checkString = backButton.value + "/tagged/";
    // リファラーURLを取得
    var referrer = document.referrer;

    // リファラーURLに「{{ blog.url }}/tagged/」が含まれているかチェック
    if (referrer.includes(checkString)) {
      // 「{{ blog.url }}/tagged/」が含まれていれば、ブラウザの履歴を使用して一つ前に戻る
      history.back();
    } else {
      // 「blog/」が含まれていなければ、{{ blog.url }}に遷移
      window.location.href = backButton.value;
    }
  });
});
document.addEventListener("DOMContentLoaded", function () {
  const backDetailButton = document.getElementById("blog_detail-back-btn");

  backDetailButton.addEventListener("click", function () {
    const checkDetailString = backDetailButton.value + "/tagged/";
    // リファラーURLを取得
    var referrer = document.referrer;

    // リファラーURLに「{{ blog.url }}/tagged/」が含まれているかチェック
    if (referrer.includes(checkDetailString)) {
      // 「{{ blog.url }}/tagged/」が含まれていれば、ブラウザの履歴を使用して一つ前に戻る
      history.back();
    } else {
      // 「blog/」が含まれていなければ、{{ blog.url }}に遷移
      window.location.href = backDetailButton.value;
    }
  });
});
